export const AUTH_UNKNOWN = 'UNKNOWN'
export const AUTHENTICATED = 'AUTHENTICATED'
export const UNAUTHENTICATED = 'UNAUTHENTICATED'

export const LOGIN_STATE = {
  WAITING_FOR_EMAIL: 'WAITING_FOR_EMAIL',
  EMAIL_LINK_SENT: 'EMAIL_LINK_SENT',
  REDIRECTING: 'REDIRECTING'
}
